import { PaginationPlayground } from "../PaginationPlayground";
import { SpreadsheetPlayground } from "../SpreadsheetPlayground";
import { StickyDataTablePlayground } from "../StickyDataTablePlayground";
import { TablePageSubHeaderPlayground } from "../TablePageSubHeaderPlayground";
import { TablesPlayground } from "../TablesPlayground";
import { ViewTablePlayground } from "../ViewTablePlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const tablesEntries: PlaygroundComponentEntry[] = [
    {
        id: "tables",
        label: "Tables",
        description: "Simple and grid tables with sorting and sticky footer.",
        group: "components",
        render: () => <TablesPlayground />,
    },
    {
        id: "sticky-data-table",
        label: "Sticky data table",
        description: "Data table with sticky header/columns.",
        group: "components",
        render: () => <StickyDataTablePlayground />,
    },
    {
        id: "pagination",
        label: "Pagination",
        description: "Page navigation controls.",
        group: "components",
        render: () => <PaginationPlayground />,
    },
    {
        id: "table-page-sub-header",
        label: "Table page sub-header",
        description: "Sub-header bar for table pages.",
        group: "components",
        render: () => <TablePageSubHeaderPlayground />,
    },
    {
        id: "view-table",
        label: "View table",
        description:
            "Pinned columns, sorting, resizing, selection, totals, row drag and drop, and native data states.",
        group: "components",
        render: () => <ViewTablePlayground />,
    },
    {
        id: "spreadsheet",
        label: "Spreadsheet",
        description:
            "Pinned and resizable columns, nested rows, sticky header, and a totals row.",
        group: "components",
        render: () => <SpreadsheetPlayground />,
    },
];
